import { render, staticRenderFns } from "./CalendarStadiumEvent.vue?vue&type=template&id=c014b4aa&"
import script from "./CalendarStadiumEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarStadiumEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c014b4aa')) {
      api.createRecord('c014b4aa', component.options)
    } else {
      api.reload('c014b4aa', component.options)
    }
    module.hot.accept("./CalendarStadiumEvent.vue?vue&type=template&id=c014b4aa&", function () {
      api.rerender('c014b4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CalendarStadiumEvent.vue"
export default component.exports